module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/haircut-mobile-0fa3c191a5a81bcc4e685fa67d678141.jpg";